import { Component, input } from '@angular/core';

@Component({
	selector: 'app-pulse-loader',
	templateUrl: './pulse-loader.component.html',
	standalone: true,
})
export class PulseLoaderComponent {
	altText = input<string>('');
	imagePath = input<string>('');
}
